import useIsPlanView from '@editor/hooks/useIsPlanView'
import { useCommentFilterStore } from '@editorStores'

/**
 * Whether the scene currently previews the position plan (Planansicht with "Positionsplan"). The
 * shared floorplan rendering then draws each element's geometry and label lines as its PDF plan
 * settings say (`positionPlanSettings.pdf`), like the export.
 */
const useIsPositionPlanPreview = (): boolean => {
  const isPlanView = useIsPlanView()
  const selectedPlan = useCommentFilterStore(state => state.selectedPlan)
  return isPlanView && selectedPlan === 'positionPlan'
}

export default useIsPositionPlanPreview
